import { useMemo, useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { RefreshCw, Search } from 'lucide-react';
import { useAdminJornadaRegistrationsList } from './hooks/useJornadaRegistrationsAdmin';

const DEFAULT_SLUG = 'chambel-cartagena-2026-05-22';

export function JornadasLandingPage() {
    const [jornadaSlug, setJornadaSlug] = useState(DEFAULT_SLUG);
    const [search, setSearch] = useState('');

    const slugFilter = useMemo(() => (jornadaSlug === '__all__' ? '' : jornadaSlug), [jornadaSlug]);

    const { data: rows = [], isLoading, refetch, isFetching } = useAdminJornadaRegistrationsList(
        slugFilter,
        search
    );

    return (
        <div className="space-y-6">
            <PageHeader
                title="Jornadas (web)"
                description="Inscripciones recibidas desde la landing pública (aipeces.com/jornadas)."
            >
                <button
                    type="button"
                    onClick={() => refetch()}
                    disabled={isFetching}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-foreground bg-muted/50"
                >
                    <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} />
                </button>
            </PageHeader>

            <div className="flex flex-wrap gap-3 items-end">
                <div>
                    <label htmlFor="jornada-slug" className="block text-xs text-muted-foreground mb-1">
                        Jornada (slug)
                    </label>
                    <select
                        id="jornada-slug"
                        value={jornadaSlug}
                        onChange={(e) => setJornadaSlug(e.target.value)}
                        className="rounded-lg border border-border bg-background px-3 py-2 text-sm min-w-[240px]"
                    >
                        <option value={DEFAULT_SLUG}>Chambel Cartagena (22 may 2026)</option>
                        <option value="__all__">Todas las jornadas</option>
                    </select>
                </div>
                <div className="relative flex-1 min-w-[200px] max-w-md">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <input
                        type="search"
                        placeholder="Buscar por nombre, email o teléfono…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full pl-10 pr-3 py-2 rounded-lg border border-border bg-background text-sm"
                    />
                </div>
            </div>

            {isLoading ? (
                <p className="text-sm text-muted-foreground">Cargando…</p>
            ) : rows.length === 0 ? (
                <p className="text-sm text-muted-foreground">No hay inscripciones.</p>
            ) : (
                <div className="rounded-xl border border-border overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-muted/50 text-left text-xs text-muted-foreground uppercase">
                                <tr>
                                    <th className="px-3 py-2 font-medium">Fecha</th>
                                    <th className="px-3 py-2 font-medium">Nombre</th>
                                    <th className="px-3 py-2 font-medium">Email</th>
                                    <th className="px-3 py-2 font-medium">Teléfono</th>
                                    <th className="px-3 py-2 font-medium">Marnific</th>
                                    <th className="px-3 py-2 font-medium">Barco</th>
                                    <th className="px-3 py-2 font-medium">Slug</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id} className="border-t border-border hover:bg-muted/30">
                                        <td className="px-3 py-2 whitespace-nowrap text-muted-foreground">
                                            {new Date(r.created_at).toLocaleString('es-ES')}
                                        </td>
                                        <td className="px-3 py-2 font-medium">{r.full_name}</td>
                                        <td className="px-3 py-2">
                                            <a href={`mailto:${r.email}`} className="text-sky-400 hover:underline">
                                                {r.email}
                                            </a>
                                        </td>
                                        <td className="px-3 py-2 whitespace-nowrap">{r.phone}</td>
                                        <td className="px-3 py-2">{r.is_marnific_member ? 'Sí' : 'No'}</td>
                                        <td className="px-3 py-2">{r.wants_boat_practice ? 'Sí' : 'No'}</td>
                                        <td className="px-3 py-2 text-xs text-muted-foreground">{r.jornada_slug}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <p className="px-3 py-2 text-xs text-muted-foreground border-t border-border">
                        {rows.length} fila{rows.length === 1 ? '' : 's'}
                    </p>
                </div>
            )}
        </div>
    );
}
